import * as Yup from 'yup';
import { RcFile } from 'antd/lib/upload';

export const manifestValidationSchema = Yup.object({
    manifestId: Yup.string().required().nullable(),
});

export const jobValidationSchema = Yup.object({
    jobId: Yup.string().required().nullable(),
});

export const customerValidationSchema = Yup.object({
    customerId: Yup.string().required().nullable(),
});

export const formTypeValidationSchema = Yup.object({
    formType: Yup.string().required().nullable(),
});

export const ensFormValidationSchema = Yup.object({
    entryTransportType: Yup.number().required().nullable(),
    formType: Yup.string().required().nullable(),
});

export const declarationValidationSchema = Yup.object({
    declarationId: Yup.string().required().nullable(),
    mrn: Yup.string().required().nullable(),
});

export const templateValidationSchema = Yup.object({
    templateId: Yup.string().nullable(),
});

export const invoiceValidationSchema = Yup.object({
    invoiceFile: Yup.mixed<RcFile>().nullable().optional(),
});

export const bulkUploadValidationSchema = Yup.object({
    s3Link: Yup.string().nullable(),
    file: Yup.mixed<File>().nullable().optional(),
});
